<template>
	<div class="home-page">
		<div v-if="!isLoading">
			<!-- 顶部 -->
			<div class="head-box">
				<Head :title="realtimeQueryCountData.icpname" @refresh="refresh" />
			</div>
			<!-- 底部 -->
			<div class="main-box">
				<div class="main-left">
					<div class="box1">
						<div class="title">
							<span class="txt"><img src="@/assets/img/t1.png" width="30" height="30px" alt="" /> 本年工作统计</span>
							<!-- <div class="select-container">
								<HjkSelect v-model="selectedYear" :options="selectOptions" placeholder="请选择" @change="handleChange" />
							</div> -->
							<span class="time">{{ CURRENTYEAR }}年1月1日-至今</span>
						</div>
						<div class="content" v-if="!loading1">
							<div class="itemBox1">
								<div class="item">
									<img src="@/assets/img/icon1.png" width="47" height="47" alt="" />
									<div class="txt">
										<p>建档人数</p>
										<p :class="changeList.includes('jdnums') ? 'redCol' : ''">{{ realtimeQueryCountData.jdnums }}人</p>
									</div>
								</div>
								<div class="item">
									<img src="@/assets/img/icon2.png" width="47" height="47" alt="" />
									<div class="txt">
										<p>老年人体检人数</p>
										<p :class="changeList.includes('oldtjnums') ? 'redCol' : ''">{{ realtimeQueryCountData.oldtjnums }}人</p>
									</div>
								</div>
							</div>
							<div class="itemBox2">
								<div class="item">
									<p>高血压随访人数</p>
									<p :class="changeList.includes('gxysfnums') ? 'redCol' : ''">{{ realtimeQueryCountData.gxysfnums }}人</p>
								</div>
								<div class="item">
									<p>糖尿病随访人数</p>
									<p :class="changeList.includes('tnbsfnums') ? 'redCol' : ''">{{ realtimeQueryCountData.tnbsfnums }}人</p>
								</div>
								<div class="item">
									<p>慢阻肺随访人数</p>
									<p :class="changeList.includes('mzfsfnums') ? 'redCol' : ''">{{ realtimeQueryCountData.mzfsfnums }}人</p>
								</div>
							</div>
                            <div class="itemBox2">
								<div class="item">
									<p>高血压随访人次</p>
									<p :class="changeList.includes('gxysfcs') ? 'redCol' : ''">{{ realtimeQueryCountData.gxysfcs }}人</p>
								</div>
								<div class="item">
									<p>糖尿病随访人次</p>
									<p :class="changeList.includes('tnbsfcs') ? 'redCol' : ''">{{ realtimeQueryCountData.tnbsfcs }}人</p>
								</div>
								<div class="item">
									<p>慢阻肺随访人次</p>
									<p :class="changeList.includes('mzfsfcs') ? 'redCol' : ''">{{ realtimeQueryCountData.mzfsfcs }}人</p>
								</div>
							</div>
							<div class="itemBox1">
								<div class="item">
									<img src="@/assets/img/icon3.png" width="47" height="47" alt="" />
									<div class="txt">
										<p>累计档案开放数</p>
										<p :class="changeList.includes('dakfnums') ? 'redCol' : ''">{{ realtimeQueryCountData.dakfnums }}人</p>
									</div>
								</div>
								<div class="item">
									<img src="@/assets/img/icon4.png" width="47" height="47" alt="" />
									<div class="txt">
										<p>档案调阅数</p>
										<p :class="changeList.includes('dadynums') ? 'redCol' : ''">{{ realtimeQueryCountData.dadynums }}人</p>
									</div>
								</div>
							</div>
						</div>
						<Loading v-else />
					</div>
					<div class="box2">
						<!-- 0~3周岁儿童管理 -->
						<div class="itemBox">
							<div class="title">0~3周岁儿童管理</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData4" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档人数
										</p>
										<p>
											<span>{{ t1Data.ldssnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.ldssglnums }}</span
											>人
										</p>
									</div>
								</div>
							</div>
						</div>
						<!-- 4~6周岁儿童管理 -->
						<div class="itemBox">
							<div class="title">4~6周岁儿童管理</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData5" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档人数
										</p>
										<p>
											<span>{{ t1Data.sdlsnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.sdlsglnums }}</span
											>人
										</p>
									</div>
								</div>
							</div>
						</div>
						<!-- 孕产妇健康管理 -->
						<div class="itemBox">
							<div class="title">孕产妇健康管理</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData6" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档人数
										</p>
										<p>
											<span>{{ t1Data.ycfjdnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.ycfglnums }}</span
											>人
										</p>
									</div>
								</div>
							</div>
						</div>
						<!-- 老年人健康管理 -->
						<div class="itemBox">
							<div class="title">老年人健康管理</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData7" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											老年人常住人口数
										</p>
										<p>
											<span>{{ t1Data.lnrcznums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档人数
										</p>
										<p>
											<span>{{ t1Data.oldjdnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											规范管理人数
										</p>
										<p>
											<span>{{ t1Data.oldgfglnums }}</span
											>人
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main-center">
					<div class="top">
						<div class="title">
							<img src="@/assets/img/jian1.png" width="31" height="19" alt="" />
							<span>{{ t1Data.icpname }}基本情况</span>
							<img src="@/assets/img/jian2.png" width="31" height="19" alt="" />
						</div>
						<div class="content">
							<div class="map">
								<img src="@/assets/img/map.png" alt="" />
								<span v-for="(item, index) in countryList" :key="item.value" :class="'pos' + index" @click="toDetail(item.value)">
									<div class="tip">{{ item.name }}</div>
								</span>
							</div>
							<div class="itemBox">
								<div class="item">
									<div class="img">
										<img src="@/assets/img/p1.png" width="40px" height="40px" alt="" />
									</div>
									<div class="txt1">
										<p>总户数</p>
										<p>{{ t1Data.householdnums }}</p>
									</div>
									<div class="txt2">
										<p>
											<span>{{ t1Data.fwjgnums }}</span
											>个
										</p>
										<p>服务机构</p>
									</div>
									<div class="txt2">
										<p>
											<span>{{ t1Data.dtglnums || 0 }}</span
											>个
										</p>
										<p>动态管理人数</p>
									</div>
								</div>
								<div class="item">
									<div class="img">
										<img src="@/assets/img/p2.png" width="40px" height="40px" alt="" />
									</div>
									<div class="txt1">
										<p>总人口数</p>
										<p>{{ t1Data.peoplenums }}</p>
									</div>
									<div class="txt2">
										<p>
											<span>{{ t1Data.cwssnums }}</span
											>个
										</p>
										<p>村级服务机构</p>
									</div>
									<div class="txt2">
										<p>
											<span>{{ t1Data.dtglquotiety || 0 }}</span
											>%
										</p>
										<p>动态管理率</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bot">
						<Rank :rankData="rankData" v-if="!loading2" />
						<Loading v-else />
					</div>
				</div>
				<div class="main-right">
					<div class="box1">
						<div class="title">
							<span class="txt">
								<img src="@/assets/img/t2.png" width="30" height="30px" alt="" />
								家庭医生签约服务
							</span>
						</div>
						<div class="content">
							<div class="top">
								<div class="item item1">
									<p>总签约人数</p>
									<p>
										<span>{{ t1Data.zqynums || 0 }}</span
										>人
									</p>
								</div>
								<div class="item item2">
									<p>签约率</p>
									<p>
										<span>{{ t1Data.qyquotiety || 0 }}</span
										>%
									</p>
								</div>
							</div>
							<div class="bot">
								<div class="item">
									<div class="txt1">
										<img src="@/assets/img/star.png" width="20" height="20" alt="" />
										重点人群
									</div>
									<div class="txt2">{{ t1Data.zdrqnums || 0 }}人</div>
									<div class="chart">
										<ChartPie width="100%" height="100px" :chartData="pieData1" />
									</div>
								</div>
								<div class="item">
									<div class="txt1">
										<img src="@/assets/img/pepole.png" width="20" height="20" alt="" />
										一般人群
									</div>
									<div class="txt2">{{ t1Data.ybrqnums || 0 }}人</div>
									<div class="chart">
										<ChartPie width="100%" height="100px" :chartData="pieData2" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="box2">
						<!-- 原发性高血压 -->
						<div class="itemBox">
							<div class="title">原发性高血压</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData1" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档在册人数
										</p>
										<p>
											<span>{{ t1Data.gxyhznums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.gxyglnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											规范管理人数
										</p>
										<p>
											<span>{{ t1Data.gxygfglnums }}</span
											>人
										</p>
									</div>
								</div>
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData9" />
								</div>
							</div>
						</div>
						<!-- 2型糖尿病 -->
						<div class="itemBox">
							<div class="title">2型糖尿病</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData2" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档在册人数
										</p>
										<p>
											<span>{{ t1Data.tnbhznums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.tnbglnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											规范管理人数
										</p>
										<p>
											<span>{{ t1Data.tnbgfglnums }}</span
											>人
										</p>
									</div>
								</div>
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData10" />
								</div>
							</div>
						</div>
						<!-- 慢性阻塞性肺疾病 -->
						<div class="itemBox">
							<div class="title">慢性阻塞性肺疾病</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData3" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档在册人数
										</p>
										<p>
											<span>{{ t1Data.mzfhznums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.mzfglnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											规范管理人数
										</p>
										<p>
											<span>{{ t1Data.mzfgfglnums }}</span
											>人
										</p>
									</div>
								</div>
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData11" />
								</div>
							</div>
						</div>
						<!-- 严重精神障碍 -->
						<div class="itemBox">
							<div class="title">严重精神障碍</div>
							<div class="content">
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData8" />
								</div>
								<div class="txt">
									<div class="item">
										<p>
											<img src="@/assets/img/user2.png" width="20" height="20" alt="" />
											建档在册人数
										</p>
										<p>
											<span>{{ t1Data.jsbjdnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											管理人数
										</p>
										<p>
											<span>{{ t1Data.jsbglnums }}</span
											>人
										</p>
									</div>
									<div class="item">
										<p>
											<img src="@/assets/img/user1.png" width="20" height="20" alt="" />
											规范管理人数
										</p>
										<p>
											<span>{{ t1Data.jsbgfglnums }}</span
											>人
										</p>
									</div>
								</div>
								<div class="chart">
									<ChartGauge width="100%" height="100px" :chartData="gaugeData12" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Loading v-else />
	</div>
</template>

<script>
import Loading from "@/components/loading";
import Head from "@/components/Head";
import Rank from "@/components/Rank";
import ChartPie from "@/components/Pie";
import ChartGauge from "@/components/Gauge";
// import ChartPie3D from "@/components/chartPie";
// import oldPie from "@/components/oldPie";
// import HjkSelect from "@/components/HjkSelect";
import { realtimeQueryCount, realtimeQueryList, t1QueryCount } from "@/service/request";
export default {
	name: "homepage",
	components: {
		Loading,
		Head,
		Rank,
		ChartPie,
		ChartGauge,
		// ChartPie3D,
		// oldPie,
		// HjkSelect,
	},
	data() {
		return {
			realtimeQueryCountData: {},
			changeList: [],
			t1Data: {},
			// 下拉组件选中的值
			selectedYear: String(new Date().getFullYear()),

			rankData: {
				name: "",
				listData: [],
			},
			pieData1: {
				value: 0,
				name: "重点人群签约率",
			},
			pieData2: {
				value: 0,
				name: "一般人群签约率",
			},

			// 0~3周岁
			gaugeData4: {
				value: 0,
				name: "管理率",
				color: 0,
			},
			// 4~6周岁
			gaugeData5: {
				value: 0,
				name: "管理率",
				color: 0,
			},
			// 孕产妇
			gaugeData6: {
				value: 0,
				name: "管理率",
				color: 0,
			},
			// 老年人
			gaugeData7: {
				value: 0,
				name: "管理率",
				color: 0,
			},
			/** 原发性高血压 */
			gaugeData1: {
				value: 0,
				name: "规范管理率",
				color: 0,
			},
			/** 2型糖尿病 */
			gaugeData2: {
				value: 0,
				name: "规范管理率",
				color: 1,
			},
			/** 慢阻肺 */
			gaugeData3: {
				value: 0,
				name: "规范管理率",
				color: 2,
			},
			/** 严重精神障碍 */
			gaugeData8: {
				value: 0,
				name: "规范管理率",
				color: 0,
			},
			/** 原发性高血压 */
			gaugeData9: {
				value: 10,
				name: "管理率",
				color: 0,
			},
			/** 2型糖尿病 */
			gaugeData10: {
				value: 30,
				name: "管理率",
				color: 1,
			},
			/** 慢阻肺 */
			gaugeData11: {
				value: 20,
				name: "管理率",
				color: 2,
			},
			/** 严重精神障碍 */
			gaugeData12: {
				value: 40,
				name: "管理率",
				color: 3,
			},
			isLoading: true,
			timer: null,
			countryList: [
				{
					name: "槐埝乡卫生院",
					value: "14102722",
				},
				{
					name: "东张乡卫生院",
					value: "14102721",
				},
				{
					name: "响水河镇卫生院",
					value: "14102711",
				},
				{
					name: "浮山县中医院",
					value: "14102730",
				},
				{
					name: "天坛镇卫生院",
					value: "14102710",
				},
				{
					name: "北王镇卫生院",
					value: "14102723",
				},
				{
					name: "寨圪塔乡卫生院",
					value: "14102726",
				},
				{
					name: "张庄镇卫生院",
					value: "14102720",
				},
			],
			loading1: true,
			loading2: true,
		};
	},
	created() {
		window.setRem();
		if (sessionStorage.selectedYear) {
			this.selectedYear = sessionStorage.selectedYear;
		} else {
			sessionStorage.selectedYear = this.selectedYear;
		}
		let params = { conditions: { slevel: "1", icpcode: "141027" } };
		this.initData(params);
		clearInterval(this.timer);
		this.timer = setInterval(() => {
			if (this.$router.path == "/index") {
				this.fetchData1(params, "refresh");
				this.fetchData2(params, "refresh");
			}
		}, 5 * 60 * 1000);
	},
	computed: {
		/**
		 * 动态生成日期范围选项
		 */
		selectOptions() {
			const now = new Date();
			const currentYear = now.getFullYear();
			const lastYear = currentYear - 1;
			return [
				{ label: `${currentYear}年1月1日至今`, value: String(currentYear) },
				{ label: `${lastYear}年全年`, value: String(lastYear) },
			];
		},
		/**
		 * 获取当前年份
		 */
		CURRENTYEAR() {
			return new Date().getFullYear();
		},
	},
	methods: {
		handleChange(option) {
			sessionStorage.selectedYear = String(option.value);
		},
		initData(params) {
			this.loadData(params);
		},
		loadData(params) {
			this.isLoading = true;
			this.fetchData1(params);
			this.fetchData2(params);
			const promises = [
				this.fetchData3(params),
				// 更多接口
			];
			Promise.all(promises)
				.then(() => {
					// 所有接口加载完成
					this.isLoading = false;
				})
				.catch((error) => {
					this.isLoading = false;
					console.error("数据加载失败", error);
				});
		},
		fetchData1(params, type) {
			if (type == "refresh") {
				this.loading1 = false;
			} else {
				this.loading1 = true;
			}

			return realtimeQueryCount(params)
				.then((res) => {
					this.realtimeQueryCountData = res.data;
					this.changeList = res.data && res.data.changelist ? res.data.changelist : [];
					this.loading1 = false;
				})
				.catch((e) => {
					console.log(e);
					this.loading1 = false;
				});
		},
		fetchData2(params, type) {
			if (type == "refresh") {
				this.loading2 = false;
			} else {
				this.loading2 = true;
			}

			return realtimeQueryList(params)
				.then((res) => {
					this.rankData = {
						name: "",
						listData: res.data.dataList,
					};
					this.loading2 = false;
				})
				.catch((e) => {
					console.log(e);
					this.loading2 = false;
				});
		},
		fetchData3(params) {
			return t1QueryCount(params)
				.then((res) => {
					this.t1Data = res.data;
					this.pieData1 = {
						value: this.t1Data.zdrqquotiety || 0,
						name: "重点人群签约率",
					};
					this.pieData2 = {
						value: this.t1Data.ybrqquotiety || 0,
						name: "一般人群签约率",
					};

					this.gaugeData4 = {
						value: this.t1Data.ldssquotiety || 0,
						name: "管理率",
						color: 0,
					};
					this.gaugeData5 = {
						value: this.t1Data.sdlsquotiety || 0,
						name: "管理率",
						color: 1,
					};
					this.gaugeData6 = {
						value: this.t1Data.ycfquotiety || 0,
						name: "管理率",
						color: 2,
					};
					this.gaugeData7 = {
						value: this.t1Data.oldgfquotiety || 0,
						name: "规范管理率",
						color: 3,
					};

					this.gaugeData1 = {
						value: this.t1Data.gxygfquotiety || 0,
						name: "规范管理率",
						color: 0,
					};
					this.gaugeData2 = {
						value: this.t1Data.tnbgfquotiety || 0,
						name: "规范管理率",
						color: 1,
					};
					this.gaugeData3 = {
						value: this.t1Data.mzfgfquotiety || 0,
						name: "规范管理率",
						color: 2,
					};
					this.gaugeData8 = {
						value: this.t1Data.jsbgfquotiety || 0,
						name: "规范管理率",
						color: 3,
					};

					this.gaugeData9 = {
						value: this.t1Data.gxyquotiety || 0,
						name: "管理率",
						color: 0,
					};
					this.gaugeData10 = {
						value: this.t1Data.tnbquotiety || 0,
						name: "管理率",
						color: 1,
					};
					this.gaugeData11 = {
						value: this.t1Data.mzfquotiety || 0,
						name: "管理率",
						color: 2,
					};
					this.gaugeData12 = {
						value: this.t1Data.jsbquotiety || 0,
						name: "管理率",
						color: 3,
					};
				})
				.catch((e) => {
					console.log(e);
				});
		},
		refresh() {
			let params = { conditions: { slevel: "1", icpcode: "141027" } };
			this.fetchData3(params);
		},
		toDetail(icpcode) {
			this.$router.push({
				path: "/detail",
				query: { icpcode: icpcode },
			});
		},
	},
};
</script>
<style>
.redCol {
	color: #f56c6c !important;
}
</style>
<style lang="stylus" scoped>
.home-page {
  .main-box {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 18px 20px;

    .box1 {
      width: 100%;
      height: 320px;
      background: url('../assets/img/box1.png') no-repeat center bottom;
      background-size: 100% 314px;
      position:relative
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0 0 24px;

        .txt {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;
          background: linear-gradient(0deg, #AAEAFA 0%, #FFFFFF 91.357421875%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        img {
          vertical-align: middle;
        }

        .time {
          line-height: 20px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 20px;
          color: #AAEAFA;
        }
      }
    }

    .box2 {
      width: 100%;
      height: 629px;
      background: url('../assets/img/box2.png') no-repeat;
      background-size: 100% 100%;
      margin-top: 20px;

      .title {
        width: 211px;
        height: 40px;
        background: url('../assets/img/t3.png') no-repeat center bottom;
        background-size: 100% 100%;
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 20px;
        color: #00DED6;
        line-height: 30px;
        margin: 0 auto;
      }
    }

    .main-left {
      width: 446px;

      .box1 {
        .content {
          padding: 40px 15px 0;

          .itemBox1 {
            display: flex;
            align-items: center;

            .item {
              display: flex;
              align-items: center;

              &:last-child {
                margin-left: 50px;
              }

              .txt {
                width: 113px;
                height: 45px;
                background: url('../assets/img/b0.png') no-repeat center bottom;
                background-size: 100% 38px;
                margin-left: 9px;
                padding: 0 0 0 10px;

                p {
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #AAEAFA;
                  line-height: 14px;

                  &:last-child {
                    margin-top: 9px;
                    font-weight: 500;
                    font-size: 20px;
                    color: #FEFFFF;
                    line-height: 20px;
                  }
                }
              }
            }
          }

          .itemBox2 {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 13px 0 13px;

            .item {
              p {
                width: 123px;
                text-align: center;

                &:first-child {
                  height: 26px;
                  background: linear-gradient(90deg, rgba(14, 85, 91, 0) 0%, rgba(14, 85, 91, 0.99) 52%, rgba(14, 85, 91, 0) 100%);
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #AAEAFA;
                  line-height: 26px;
                }

                &:last-child {
                  margin-top: 5px;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 20px;
                  color: #FEFFFF;
                  line-height: 20px;
                }
              }
            }
          }
        }
      }

      .box2 {
        .itemBox {
          height: 155px;
          padding: 7px 20px 0;

          .content {
            display: flex;
            align-items: center;

            .chart {
              width: 150px;
            }

            .txt {
              .item {
                min-height:35px;
                display: flex;
                align-items: center;
                p {
                  display: flex;
                  align-items: center;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 14px;
                  color: #AAEAFA;
                  line-height: 16px;

                  img {
                    margin-right: 5px;
                  }

                  &:first-child {
                    width: 140px;
                  }

                  &:last-child {
                    font-family: Arial;
                    font-weight: 500;
                    font-size: 18px;
                    color: #FFFFFF;
                    line-height: 24px;

                    span {
                      font-weight: 900;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .main-center {
      flex: 1;
      margin: 0 23px;

      .top {
        height: 320px;

        .title {
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            background: linear-gradient(0deg, #AAEAFA 0%, #FFFFFF 91.357421875%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin: 0 10px;
          }
        }

        .content {
          margin-top: 24px;
          display: flex;
          align-items: center;

          .map {
            justify-content: center;
            width: 419px;
            height: 276px;
            overflow: hidden;
            background: #042431;
            border-radius: 10px;
            border: 1px solid #02A8AE;
            position: relative;
            span {
              position:absolute;
              cursor:pointer;
              width:29px
              height:29px
              background: url('../assets/img/pos.png') no-repeat center
              transition: all 0.5s;
              .tip{
                width:auto
                word-break: keep-all
                padding: 0 10px
                left:50%
                margin-left:-55px
                position:absolute;
                top:-24px;
                background: #021B25;
                border-radius: 7px;
                border: 1px solid #00ADED;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 14px;
                color: #FEFFFF;
                line-height: 24px
                display:none
                text-align:center
                z-index:99
              }
              &:hover{
                .tip{
                  display:block
                 }
              }
            }
            .pos0 {
              left:30px;
              top:135px;
              .tip{
                margin-left:-40px
              }
            }
            .pos1 {
              left:75px;
              top:168px;
            }
            .pos2 {
              left:90px;
              top:145px;
            }
            .pos3 {
              left:155px;
              top:102px;
            }
            .pos4 {
              left:184px;
              top:120px;
            }
            .pos5 {
              left:184px;
              top:45px;
            }
            .pos6 {
              left:315px;
              top:175px;
            }
            .pos7 {
              left:105px;
              top:105px;
            }
          }

          .itemBox {
            margin-left: 20px;
            height: 276px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .item {
              display: flex;
              align-items: center;
              padding-left: 19px;
              height: 128px;
              background: linear-gradient(0deg, #004554 0%);
              border-radius: 10px;

              .img {
                width: 99px;
                height: 78px;
                background: url('../assets/img/b7.png') no-repeat center bottom;
                background-size: 100% 55px;
                text-align: center;
              }

              .txt1 {
                margin-left: 25px;

                p {
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  font-size: 14px;
                  color: #FFFFFF;
                  line-height: 14px;

                  &:last-child {
                    font-family: D-DIN;
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 24px;
                    margin-top: 10px;
                  }
                }
              }

              .txt2 {
                margin-left: 55px;
                text-align: center;

                p {
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  font-size: 14px;
                  color: #FFFFFF;
                  line-height: 14px;

                  &:first-child {
                    font-family: D-DIN;
                    font-weight: bold;
                    color: #00FDFF;
                    font-size: 18px;
                    line-height: 24px;
                    margin-bottom: 8px;

                    span {
                      font-size: 24px;
                      margin-right: 3px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .bot {
        margin-top: 20px;
        width: 100%;
        height: 629px;
        background: url('../assets/img/box3.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .main-right {
      width: 446px;

      .box1 {
        .content {
          padding: 32px 16px 0;

          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
              width: 192px;
              height: 65px;
              padding-left: 72px;

              p {
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #AAEAFA;
                line-height: 16px;

                &:last-child {
                  font-family: Adobe Heiti Std R;
                  font-weight: 400;
                  font-size: 18px;
                  color: #FFFFFF;
                  line-height: 22px;
                  margin: 15px 0 0 18px;

                  span {
                    font-family: Arial;
                    font-size: 22px;
                    font-weight: 900;
                  }
                }
              }
            }

            .item1 {
              background: url('../assets/img/b8.png') no-repeat center bottom;
              background-size: 100% 62px;
            }

            .item2 {
              background: url('../assets/img/b9.png') no-repeat center bottom;
              background-size: 100% 62px;
            }
          }

          .bot {
            margin-top: 16px;
            width: 100%;
            height: 163px;
            background: linear-gradient(0deg, #004554 0%, rgba(0, 69, 84, 0) 100%);
            border: 1px solid #1693A6;
            display: flex;
            padding: 10px 0;

            .item {
              width: 50%;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #00FDFF;
              line-height: 16px;
              position: relative;

              &:first-child {
                &::before {
                  content: '';
                  top: 12px;
                  bottom: 12px;
                  position: absolute;
                  right: 0;
                  border-right: 1px solid #1693A6;
                }
              }

              .txt1 {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  margin-right: 5px;
                }
              }

              .txt2 {
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 24px;
                color: #00FDFF;
                line-height: 24px;
                margin-top: 6px;
                margin-left: 20px;
              }
            }
          }
        }
      }

      .box2 {
        .itemBox {
          height: 155px;
          padding: 7px 20px 0;

          .content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .chart {
              width: 80px;
            }

            .txt {
              .item {
                min-height:30px;
                display: flex;
                align-items: center;
                p {
                  display: flex;
                  align-items: center;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 14px;
                  color: #AAEAFA;
                  line-height: 16px;

                  img {
                    margin-right: 5px;
                  }

                  &:first-child {
                    width: 140px;
                  }

                  &:last-child {
                    font-family: Arial;
                    font-weight: 500;
                    font-size: 18px;
                    color: #FFFFFF;
                    line-height: 24px;

                    span {
                      font-weight: 900;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
